import { FormConfig, Forms } from 'sites/types';
import { SMS_OPT_IN_FEATURE_READY } from 'config/incomplete-features';

import { commonForms } from '../common/forms';

export const USForms: Forms = {
  ...commonForms,
  registration: [
    [{ name: 'firstName', type: 'input', required: true }],
    [{ name: 'lastName', type: 'input', required: true }],
    [{ name: 'email', type: 'input', inputType: 'email', required: true }],
    [{ name: 'password', type: 'password', required: true }],
    [{ name: 'emailList', type: 'checkbox' }],
    ...(!SMS_OPT_IN_FEATURE_READY
      ? []
      : ([
          [
            {
              name: 'smsOptIn',
              type: 'sms-opt-in',
              args: {
                phoneNumberFieldName: 'phoneNumber',
                ctaLabel: 'register',
              },
            },
          ],
        ] as FormConfig)),
    [{ name: 'tacOnCreateAccount', type: 'terms-and-conditions' }],
    [{ name: 'createAccount', type: 'button', buttonType: 'submit' }],
  ],
  orderLookUpReturns: [
    [
      {
        name: 'orderNo',
        type: 'input',
        inputType: 'text',
        required: true,
      },
    ],
    [{ name: 'orderEmail', type: 'input', inputType: 'email', required: true }],
    [{ name: 'billingPostalCode', type: 'input', required: true }],
    [
      {
        name: 'returnsOrderExplainerModal',
        type: 'text-to-modal',
        required: true,
      },
    ],
    [
      {
        name: 'submitButton',
        type: 'button',
        buttonType: 'submit',
      },
    ],
  ],
};
